'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ForecasterProfile = require('./ForecasterProfile');

var _ForecasterProfile2 = _interopRequireDefault(_ForecasterProfile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ForecasterProfile2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ForecasterProfile/index.js
// module id = 586
// module chunks = 11